module.exports = __webpack_public_path__ + "img/first_gift.e4246d9c.png";